/** Validators shared by the search form's sections. */

export const numberRule = (message: string, min = 0) => [
  {
    validator: async (_: unknown, v: unknown) => {
      if (!(Number(v) > min)) throw new Error(message);
    },
  },
];

export const integerRule = (message: string, min = 1) => [
  {
    validator: async (_: unknown, v: unknown) => {
      const n = Number(v);
      if (!Number.isInteger(n) || n < min) throw new Error(message);
    },
  },
];
